<template>
  <div class="panel-group d-flex">
    <!-- :style="{ paddingLeft: showIcon ? '0' : '' , height:'min-content'}" -->
    <div :class="[showIcon ? 'col-5' : 'col-4', 'd-flex']" style="padding-left: 0 !important; height: min-content;">
      <i v-if="showIcon" class="ag-icon ag-icon_placeholder " style="margin-right: 5px;"></i>
      <label :class="showIcon ? 'input-label' : 'form-label'"
        :style="formType === 'process' ? 'font-size: 0.758rem' : 'font-size: 0.8rem'">{{ label }}</label>
      <Tooltip :text="tooltip || label" placement="bottom" >
        <i v-if="showInfo" class="ag-icon ag-icon_table_info small info-icon" />
      </Tooltip>
    </div>
    <div :class="showIcon ? 'col-7' : 'col-8'" :style="showIcon ? 'padding-right: 0px !important; padding-left: 0.3rem !important;' : ''">
      <div :class="[showIcon ? 'process-checkgroup' : '', 'boxed-group']">
        <div v-if="label === 'Discovery Mode'" class="checkbox-item">
          <Checkbox v-model="selectedAll" @change="checkClick" :binary="true" class="custom-checkbox" :disabled="disabled" />
          <label class="label-check ms-2">Enable All</label>
        </div>
        <div v-for="opt in activeOptions" :key="opt.value" class="checkbox-item">
          <Checkbox v-model="selected" :input-id="`${opt.label}-${String(opt.value)}`" :value="String(opt.value)"
            :binary="false" class="custom-checkbox" :disabled="disabled || disabledSet.has(String(opt.value))" />
          <label :for="`${opt.label}-${String(opt.value)}`" class="label-check ms-2">{{ opt.label }}</label>

        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue'
import Checkbox from 'primevue/checkbox'
import Tooltip from './tooltip.vue'

const props = defineProps({
  modelValue: {
    type: Number,
    required: true
  },
  label: String,
  options: {
    type: Array,
  },
  showInfo: {
    type: Boolean,
    default: true
  },
  showIcon: {
    type: Boolean,
    default: false
  },
  formType: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  // Option values that should be disabled (read-only). Compared as strings
  disabledOptions: {
    type: Array,
    default: () => []
  },
  tooltip: {
    type: String,
    default: ''
  }
})
const selectedAll = ref(false);
const cleanedOptions = computed(() =>
  props.options.filter(opt => opt.label !== 'Na')
)
const activeOptions = computed(() => {
  return props.label === "Discovery Mode" ? cleanedOptions.value : props.options;
});
const disabledSet = computed(() => new Set((props.disabledOptions || []).map(v => String(v))))
const emit = defineEmits(['update:modelValue'])
const selected = ref([])
watch(() => props.modelValue, (newVal) => {
  if (newVal === null || newVal === undefined) {
    selected.value = [];
    selectedAll.value = false;
    return;
  }

  const selectedKeys = props.options
    .filter(opt => (Number(newVal) & Number(opt.value)) !== 0)
    .map(opt => String(opt.value))

  const allValues = activeOptions.value.map(opt => String(opt.value));
  const allSelected = allValues.every(v => selectedKeys.includes(v));
  selectedAll.value = allSelected;

  selected.value = selectedKeys;


}, { immediate: true })

watch(selected, () => {
  const allValues = activeOptions.value.map(opt => String(opt.value))
  selectedAll.value = allValues.every(val => selected.value.includes(val))

  const total = selected.value.reduce((acc, key) => acc + Number(key), 0)
  emit('update:modelValue', total)
})

const checkClick = () => {
  if (selectedAll.value) {
    selected.value = activeOptions.value.map(opt => String(opt.value))
  } else {
    selected.value = []
  }
}

</script>

<style scoped>
.panel-group {
  font-size: 0.8rem !important;
  width: 100%;
}

.form-label {
  font-weight: bold;
  color: #164b6c;
  margin-left: 0;
}

.input-label {
  margin-left: 0;
}

.info-icon {
  color: #6c757d;
}

.boxed-group {
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 12px;
  padding-bottom: 4px;
}

.process-checkgroup {
  width: 100%;
}

.checkbox-item {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.label-check {
  margin: 0;
  font-size: 0.82rem;
  margin-left: 5px;
}
::v-deep(.p-checkbox .p-checkbox-box) {
  width: 18px;   
  height: 18px;  
}
::v-deep(.p-checkbox .p-checkbox-box .p-checkbox-icon) {
  font-size: 12px; 
}
</style>
